import Box from "@mui/material/Box";
import Step from "@mui/material/Step";
import { StepIconProps } from "@mui/material/StepIcon";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import ProgressBarActiveIcon from "assets/icons/ProgressBarActive";
import ProgressBarInactiveIcon from "assets/icons/ProgressBarInactive";

function StepIcon({ active }: StepIconProps) {
  if (active) {
    return <ProgressBarActiveIcon />;
  }
  return <ProgressBarInactiveIcon />;
}

interface ProgressBarProps {
  activeStep: number;
  totalSteps: number;
  onStepChange?: (step: number) => void;
  className?: string;
}

export default function ProgressBar({
  activeStep = 0,
  totalSteps = 2,
  onStepChange,
  className = "w-full max-w-[320px]",
}: ProgressBarProps) {
  return (
    <Box className={className}>
      <Stepper activeStep={activeStep}>
        {Array.from({ length: totalSteps }).map((_, index) => (
          <Step
            key={index}
            active={activeStep === index}
            onClick={() => onStepChange?.(index)}
            className="p-0"
          >
            <StepLabel
              className="cursor-pointer"
              sx={{
                "& .MuiStepLabel-iconContainer": {
                  padding: 0,
                },
              }}
              StepIconComponent={StepIcon}
            />
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
